import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from "primereact/fileupload";
import { uploadFile } from "../../services/uploadFileService.js";
import { ErrorTemplate, SuccessTemplate } from '../common/ToastMessage/Template.jsx';
import { FileTypesAllowed } from '../../constants/file-constant.js';
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import FileUploader from '../file-uploader/FileUploader.jsx';
const defaultGraduationData = {
                  university: "",
                  department: "",
                  degree: "",
                  graduationStatus: ""
                }

const EducationQualification = ({
  translateText,
  value, 
  graduationStatusOptions, 
  degreeOptions, 
  onGraduationChange, 
  onRemoveGraduation, 
  onRemoveCertificate, 
  onUploadCertificate, 
  translation, 
  errorToast, 
  successToast, 
  invalidMessage, 
  onAddGraduation,
  hasError,
  errorMessage
}) => {
  const [educationForm, setEducationForm] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const maxEducationLength = 200;
  useEffect(() => {
    setEducationForm(value.graduations.length > 0 ? value.graduations  : [defaultGraduationData]);
    setUploadedFiles(value.certificate || []);
  }, [value.graduations, value.certificate]);

  const resetEducationInputs = (index) => () => {
    onRemoveGraduation(index);
  };

  const openCertificate = (file) => {
    window.open(file.fileResource.objectURL);
  };

  const uploadCertificate = (file) => {
    const fileUploaded = file.fileResource;
    if (fileUploaded) {
      const allowedExtensions = FileTypesAllowed.Certificates;
      
      const fileExtension = fileUploaded.name.toLowerCase().substring(fileUploaded.name.lastIndexOf('.'));
      
      if (!allowedExtensions.includes(fileExtension)) {
        errorToast?.current.show({ 
          severity: "error", 
          summary: '',
          detail: invalidMessage.uploadFileFailMessage,
          life: 3000, 
          content: (props) => ErrorTemplate(props)
        });
        return false;
      }
      
      const reader = new FileReader();
      reader.onload = async (e) => {
        const uploadedFile = await uploadFile(fileUploaded);
        uploadedFile.contentType = fileUploaded.type;
        onUploadCertificate(uploadedFile);
        
      };
      reader.readAsDataURL(fileUploaded);
      return true;
    }
  };

  const removeFile = (index) => {
    onRemoveCertificate(index);
  };

  const onUniversityChange = (value, item, index) => {
    item.university = value
    onGraduationChange(item, index)
  }

  const onDepartmentChange = (value, item, index) => {
    item.department = value
    onGraduationChange(item, index)
  }

  const onDegreeChange = (value, item, index) => {
    item.degree = value
    onGraduationChange(item, index)
  }

  const onGraduationStatusChange = (value, item, index) => {
    item.graduationStatus = value
    onGraduationChange(item, index)
  }

  const selectionTemplate = (option, value) => {
    return (
      <div className="justify-content-start align-items-center flex gap-2 text-default-txt keduall-typography text-16-normal-400">
        <RadioButton className="" value={option.value} checked={option.value === value}></RadioButton>
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.label}</div>
      </div>
    );
  };

  const [totalSize, setTotalSize] = useState(0);
  const onTemplateClear = () => {
      setTotalSize(0);
  };

  return (
    <div className="education-qualification">
      <div className="edu-container keduall-typography text-16-normal-400 text-default-txt flex flex-column">
        <div className="education-inputs-container col col-inputs w-full">
          { educationForm.map((item, i) => {
              return (
                <div key={i} className="education-form-row">
                  <div className="input-default edu-input">
                  <label className="keduall-typography text-16-normal-400">{translation.universityLabel}&nbsp;<span className="p-error">*</span></label>
                    <InputText
                      key={`university-${i}`} 
                      type="text" 
                      placeholder={translation.universityPlaceholder}
                      name="university"
                      value={item.university}
                      className={`${hasError && (!item.university) ? 'p-invalid' : ''} w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400`}
                      onChange={(e) => onUniversityChange(e.target.value, item, i)}
                      maxLength={maxEducationLength}
                    />
                    {hasError && (!item.university) && errorMessage && errorMessage()}

                  </div>
                  <div className="input-default edu-input">
                    <label className="keduall-typography text-16-normal-400">{translation.departmentLabel}&nbsp;<span className="p-error">*</span></label>
                    <InputText 
                      key={`department-${i}`} 
                      type="text" 
                      placeholder={translation.departmentPlaceholder}
                      name="department"
                      value={item.department}
                      className={`${hasError && (!item.department) ? 'p-invalid' : ''} w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400`}
                      onChange={(e) => onDepartmentChange(e.target.value, item, i)}
                      maxLength={maxEducationLength}
                    />
                    {hasError && (!item.department) && errorMessage && errorMessage()}

                  </div>
                  <div className="kedual-dropdown keduall-ripper edu-input">
                    <label className="keduall-typography text-16-normal-400">{translation.degreeLabel}&nbsp;<span className="p-error">*</span></label>
                    <Dropdown
                      options={degreeOptions}
                      type="text"
                      placeholder={translation.degreePlaceholder}
                      className={`${hasError && (!item.degree) ? 'p-invalid' : ''} w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400`}
                      value={item.degree}
                      itemTemplate={(o) => selectionTemplate(o, item.degree)}
                      onChange={(e) => { onDegreeChange(e.value, item, i)}}
                      appendTo="self"
                    />
                    {hasError && (!item.degree) && errorMessage && errorMessage()}

                  </div>
                  <div className="kedual-dropdown keduall-ripper edu-input">
                    <label className="keduall-typography text-16-normal-400">{translation.graduationStatusLabel}&nbsp;<span className="p-error">*</span></label>
                    <Dropdown
                      options={graduationStatusOptions}
                      type="text"
                      placeholder={translation.graduationStatusPlaceholder}
                      className={` ${hasError && (!item.graduationStatus) ? 'p-invalid' : ''} w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400`}
                      value={item.graduationStatus}
                      itemTemplate={(o) => selectionTemplate(o, item.graduationStatus)}
                      onChange={(e) => { onGraduationStatusChange(e.value, item, i)}}
                      appendTo="self"
                    />
                    {hasError && (!item.graduationStatus) && errorMessage && errorMessage()}

                  </div>
                  <div className="reset-btn">
                    <Button 
                      key={`reset-${i}`} 
                      type="button" 
                      icon="pi pi-times" 
                      onClick={resetEducationInputs(i)}
                      className="p-button-text shadow-none"
                    />
                  </div>
                </div>
              );
            })
          }
          <div className='flex md:justify-content-start justify-content-center'>
            <div onClick={() => onAddGraduation()} className='keduall-buttons button-filled-default-normal-primary keduall-typography circle-button-normal text-16-semibold-600 text-white-txt'><span className='pi pi-plus'></span></div>
          </div>
        </div>
        <div className='flex flex-column'>
          <div className="flex w-full justify-content-start align-items-center">
            <div className="flex keduall-typography text-16-medium-500 text-default-txt text-default-txt">{translation.educationQualificationTitle}&nbsp;<span className="p-error">*</span></div>
          </div>
          <FileUploader
            maxFileNumber={20}
            allowedFileTypes={FileTypesAllowed.CertificateInput}
            onUploadFile={uploadCertificate}
            uploadedFiles={uploadedFiles}
            removeFile={removeFile}
            translation={translation}
            invalidMessage={invalidMessage}
          /> 
          <div className='align-items-center justify-content-center flex'>
            {hasError && (value.certificate.length === 0) && errorMessage && errorMessage()}
          </div>
          <div className='text-center text-secondary-txt'>
            <small>(*) {translateText.COMMON_ITEMS_MAX_FILESIZE.replace('{{size}}', '50')}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationQualification;